import { MenuItemInfo } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { Messages } from '~src/codegen/Localize';
import { PoolID } from '~src/settings/bridge-settings/sections/types/PoolID';

import { DataConnectPoolNodesPresenceIcon } from '../dataConnectPoolNodes/DataConnectPoolNodesPresenceIcon';
import { ActionItemInfo, ActionItemType, ActionType, MoreActionsMenu } from '../MoreActionsMenu';
import { Node } from '../types/Node';
import { AcceptPoolNodeButton } from './AcceptPoolNodeButton';
import { openDeletePoolNodeDialog } from './DeletePoolNodeDialog';
import { PoolNodeStatus } from './PoolNodeStatus';
import { openRejectPoolNodeDialog } from './RejectPoolNodeDialog';


export type DataConnectPoolNodesTableRowProps = Readonly<{
  node: Node;
  index: number;
  poolTestId: string;
  siteId: string;
  poolId: PoolID;
  poolName: string;
  clusterId: string;
  refreshBaasEdgePools: () => void;
}>;


export function DataConnectPoolNodesTableRow(props: DataConnectPoolNodesTableRowProps) {
  const { node, index, poolTestId, siteId, poolName, clusterId, refreshBaasEdgePools } = props;
  const cellClass = tableCellMaxWidth + (FeatureFlags.edgeMultiPoolEnabled ? ' tb-data-grid-separator-row' : '');

  const targetSelectItem: MenuItemInfo[] = [
    { displayValue: Messages.dataConnectSiteSettingsRejectPoolNodeButton(), value: ActionType.REJECT, disabled: disableRejectPoolNode(node.nodeStatus) },
    { displayValue: Messages.deleteMessage(), value: ActionType.DELETE, disabled: !node.allowDelete},
  ];

  return <>
    <td className={cellClass}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'node-name-cell' + poolTestId}>
        {node.nodeName}
      </span>
    </td>
    <td className={cellClass}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'node-ip-cell' + poolTestId}>
        {node.nodeIp}
      </span>
    </td>
    <td className={cellClass}>
      {DataConnectPoolNodesPresenceIcon(node, poolTestId)}
    </td>
    <td className={cellClass}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'node-actions-cell' + poolTestId}>
        {
        showAcceptNodeButton(node) ? <AcceptPoolNodeButton
          node={node}
          index={index}
          siteId={siteId}
          clusterId={clusterId}
          refreshBaasEdgePools= {refreshBaasEdgePools}
        /> : <></>
        }

        <MoreActionsMenu
          targetItemInfo={targetSelectItem}
          actionType= {ActionItemType.NODE_ACTION}
          actionItemInfo={{nodeId: node.nodeId, poolName: poolName,nodeName: node.nodeName,
                      clusterId:clusterId,  siteId: siteId,
                      refreshBaasEdgePools: refreshBaasEdgePools }}
          onHandleMenuSelect={onHandleMenuSelect}
        />
       </span>
    </td>
  </>;
}

const tableCellMaxWidth = style({
  maxWidth: 200,
  overflow: 'hidden'
});

const showAcceptNodeButton = (node: Node) =>{
  if(node.nodeStatus === PoolNodeStatus.UNINITIALIZED) {
      return true;
  }
  return false;
};


const onHandleMenuSelect = (actionItem: ActionItemInfo, actionType: string) => {
    if (actionType === ActionType.REJECT) {
      openRejectPoolNodeDialog(actionItem);
    } else if (actionType === ActionType.DELETE) {
      openDeletePoolNodeDialog(actionItem);
    }

};

const disableRejectPoolNode = (nodeStatus: PoolNodeStatus) => {
  return !(nodeStatus === PoolNodeStatus.UNINITIALIZED);
};
